<template lang="pug">
    v-container.mx-auto
        v-row
            v-col.d-flex.justify-start
                v-btn(color="primary" small outlined ripple @click="displayDetailsView()")
                    v-icon mdi-arrow-left
                    | Appointments


        .text-subtitle-2.subtitle-2-padding.text-center(style="margin-top: 20px;")
            | Create New Appointment

        Form(
            v-if="!isLoading"
            :show-vehicle-form="showVehicleForm"
            :create-integration-appointment="createIntegrationAppointment"
            :current-campaign-customer="currentCampaignCustomer"
            :integration-vehicles="integrationVehicles"
            :integration-customer="integrationCustomer"
            :customer-vehicles="customerVehicles"
            :current-integration="currentIntegration"
            :first-customer-vehicle="firstCustomerVehicle"
            :display-slots-view="displaySlotsView"
            :scoped-slot="scopedSlot",
            :set-integration-appointment-details="setIntegrationAppointmentDetails"
            :slot-form-object="slotFormObject",
            :show-snackbar="showSnackbar"
            :eligible-to-save-delivery-contact="eligibleToSaveDeliveryContact"
            :primary-customer-address="primaryCustomerAddress"
            :update-integration-vehicles="updateIntegrationVehicles"
            :handle-add-customer-vehicle="handleAddCustomerVehicle"
            :vehicle-info="vehicleInfo"
            :selected-vehicle="selectedVehicle"
            :customer-communication-info="customerCommunicationInfo"
            :handle-create-vehicle="handleCreateVehicle"
            :set-selected-vehicle="setSelectedVehicle"
        )

        .text-center(v-else)
            v-progress-circular(
                :size='100'
                :width='10'
                color='var(--volie-blue)'
                indeterminate
                style="margin-top: 100px; margin-bottom: 100px;"
            )

</template>

<script lang="ts">
    import Vue from 'vue';

    // Components
    import Form from '@/components/communication_center/shared/tabs/integration/form.vue';

    // Data
    import { CreateIntegrationAppointment } from "@/data";

    export default Vue.extend({
        data() {
            return {
                isLoading: false,
                showVehicleForm: false,
                integrationsAcceptingOpcode: ["xtime"],
                integrationsAcceptingDeliveryContact: ["tekion"],
                integrationsAcceptingCustomerPhones: ["tekion", "xtime"],
                integrationsAcceptingCustomerAddresses: ["tekion"],
                integrationsAcceptingCompanyName: ["tekion"],
                integrationsAcceptingPreferredCommunicationMode: ["tekion"],
                integrationsAcceptingPreferredContactType: ["tekion"],
                integrationsAcceptingCustomerType: ["tekion"],
                integrationsAcceptingVehicleVin: ["tekion"],
                integrationsAcceptingVehicleLicensePlate: ["tekion"],
                integrationsAcceptingVehicleLastServiceDate: ["tekion"],
                integrationsAcceptingPhoneTypes: ["tekion"],
                integrationsAcceptingPhoneIsPrimary: ["tekion"],
                integrationsAcceptingVehicleOdometer: ["xtime"],
            }
        },
        methods: {
            createIntegrationAppointment(formAppointment) {
                if (!formAppointment || !this.slotFormObject) {
                    this.showSnackbar("error", "Unable to create appointment")
                    return;
                }

                // must have current integration (tekion, xtime, etc), integration customer, current campaign customer (volie campaign customer)
                if (!this.currentIntegration || this.currentIntegration === "" || !this.currentCampaignCustomer || !this.integrationCustomer) {
                    this.showSnackbar("error", "Unable to create appointment")
                    return;
                }

                // set up customer phone params
                let customerPhones = []
                if (this.integrationCustomer.phones?.length > 0 && this.integrationsAcceptingCustomerPhones.includes(this.currentIntegration)) {
                    for (let i = 0; i < this.integrationCustomer.phones.length; i++) {
                        const customerPhone = {
                            phone_number: this.integrationCustomer.phones[i]?.number || null,
                            phone_type: this.integrationsAcceptingPhoneTypes?.includes(this.currentIntegration) ? this.integrationCustomer.phones[i]?.phone_type || null : null,
                            is_primary: this.integrationsAcceptingPhoneIsPrimary?.includes(this.currentIntegration) ? this.integrationCustomer.phones[i]?.is_primary : null,
                        }

                        customerPhones.push(customerPhone)
                    }
                }

                // set up single customer address
                // want to set if is_current is true, else get first address in array
                let customerAddress = null
                if (this.integrationCustomer.addresses?.length > 0 && this.integrationsAcceptingCustomerAddresses.includes(this.currentIntegration)) {
                    let selectedAddress = null
                    for (let i = 0; i < this.integrationCustomer.addresses.length; i++) {
                        const singleAddress = this.integrationCustomer.addresses[i]
                        if (singleAddress?.is_current) {
                            selectedAddress = singleAddress
                            break;
                        }
                    }

                    // if no address is marked as current, set first in the array
                    if (!selectedAddress) {
                        selectedAddress = this.integrationCustomer.addresses[0]
                    }

                    // map params to customerAddress
                    customerAddress = {
                        line1: selectedAddress?.line1 || null,
                        line2: selectedAddress?.line2 || null,
                        zip_code: selectedAddress?.zip || null,
                        state: selectedAddress?.state || null,
                        country: selectedAddress?.country || null,
                        city: selectedAddress?.city || null,
                    }
                }

                // customer info (from integrationCustomer)
                const customerParams = {
                    customer_sid: this.integrationCustomer?.sid || "",
                    customer_arc_sid: this.integrationCustomer?.arc_sid || "",
                    customer_company_name: this.integrationsAcceptingCompanyName?.includes(this.currentIntegration) ? this.integrationCustomer?.company_name || "" : null,
                    customer_email: formAppointment?.emailAddress || "",
                    customer_first_name: this.integrationCustomer?.first_name || "",
                    customer_last_name: this.integrationCustomer?.last_name || "",
                    customer_preferred_communication_mode: this.integrationsAcceptingPreferredCommunicationMode?.includes(this.currentIntegration) ? this.integrationCustomer?.preferred_communication_mode || "" : null,
                    customer_preferred_contact_type: this.integrationsAcceptingPreferredContactType?.includes(this.currentIntegration) ? this.integrationCustomer?.preferred_contact_type || "" : null,
                    customer_type: this.integrationsAcceptingCustomerType?.includes(this.currentIntegration) ? this.integrationCustomer?.customer_type || "" : null,
                    address: customerAddress || null,
                    phones: customerPhones || null,
                    status: null,
                }

                // vehicle info (selected in form from integrationVehicles)
                const vehicleParams = {
                    vehicle_sid: formAppointment.vehicleSid || "",
                    vehicle_make: formAppointment.vehicleMake || "",
                    vehicle_model: formAppointment.vehicleModel || "",
                    vehicle_vin: this.integrationsAcceptingVehicleVin?.includes(this.currentIntegration) ? formAppointment.vehicleVin || "" : null,
                    vehicle_year: formAppointment.vehicleYear || "",
                    vehicle_odometer: this.integrationsAcceptingVehicleOdometer?.includes(this.currentIntegration) ? this.selectedVehicle?.latest_odometer_value || "" : null,
                    // hard coded, no info on customer vehicle info from get customers request
                    // create appointment request requires these
                    vehicle_color: "",
                    vehicle_trim: "",
                    vehicle_last_service_date: this.integrationsAcceptingVehicleLastServiceDate?.includes(this.currentIntegration) ? formAppointment.vehicleLastServiceDate || 0 : null,
                    vehicle_license: null,
                }

                if (this.integrationsAcceptingVehicleLicensePlate?.includes(this.currentIntegration)) {
                    vehicleParams.vehicle_license = {
                        license_plate: formAppointment.vehicleLicensePlate || "",
                        license_state: formAppointment.vehicleLicenseState || "",
                        license_country: formAppointment.vehicleLicenseCountry || "",
                    }
                }

                // for delivery contact is active params
                let deliveryContact = null
                if (this.integrationsAcceptingDeliveryContact?.includes(this.currentIntegration)) {
                    deliveryContact = {...customerParams}
                    deliveryContact.status = "ACTIVE"
                }

                const appointmentParams = {
                    // sids
                    shop_sid: this.slotFormObject.integrationShopSid || "",
                    service_advisor_sid: this.slotFormObject.integrationServiceAdvisorSid || "",
                    transportation_type_sid: "", // will be filled in below
                    transport_type: "", // will be filled in below
                    
                    // appointment params
                    opcode: this.integrationsAcceptingOpcode?.includes(this.currentIntegration) ? this.slotFormObject.opcode || "" : null,
                    appointment_date_time: formAppointment.appointmentDateTime || "",
                    delivery_contact_same_as_customer: this.integrationsAcceptingDeliveryContact?.includes(this.currentIntegration) ? formAppointment.deliveryContactSameAsCustomer || true : null,
                    customer_comments: formAppointment.customerComments || "",
                    notify_customer: formAppointment.notifyCustomer || false,

                    // objects
                    customer: customerParams,
                    vehicle: vehicleParams || null,
                    jobs: [], // TODO: blank for now, will need opcode jobs later
                    delivery_contact: deliveryContact || null,
                }

                // sids / names
                // xtime specific logic
                if (this.currentIntegration === "xtime") {
                    appointmentParams.transport_type = this.slotFormObject?.integrationTransportationTypeSid || "";
                } else {
                    appointmentParams.transportation_type_sid = this.slotFormObject?.integrationTransportationTypeSid || "";
                }

                const options = {
                    // current integration
                    integration: this.currentIntegration || null,
                    
                    // relevant volie ids
                    campaign_customer_id: this.currentCampaignCustomer.campaign_customer_id || 0,
                    organization_id: this.currentCampaignCustomer.organization_id || 0,
                    customer_vehicle_id: formAppointment?.customerVehicleId || 0,

                    // appointment info
                    appointment_info: appointmentParams || null,
                }

                this.isLoading = true;

                CreateIntegrationAppointment(options).then((response) => {
                    if (response?.Data?.integration_appointment?.appointment_sid?.length > 0) {
                        let appointment = response.Data.integration_appointment;

                        // success
                        this.showSnackbar("success", "Succesfully scheduled appointment")
                        this.setAppointmentIdForIntegration(response.Data.appointment_id); // volie created appointment id
                        this.addNewAppointment(appointment);
                        this.displayDetailsView();
                        this.getIntegrationAppointments();
                    } else {
                        this.showSnackbar("error", "Unable to schedule appointment");
                        if (response?.Data?.api_status > 0){
                            this.setIntegrationError(response.Data.api_status);
                        } else if (response?.Data?.api_status === 0 && response?.Data?.appointment_id === 0) {
                            this.showSnackbar("error", "Unable to create volie appointment");
                        }
                    }
                    this.isLoading = false;
                });
            }
        },
        components: {
            Form,
        },
        props: {
            addNewAppointment: Function,
            currentCampaignCustomer: Object,
            displaySlotsView: Function,
            displayDetailsView: Function,
            integrationCustomer: Object,
            scopedSlot: Object,
            slotFormObject: Object,
            customerVehicles: Array,
            firstCustomerVehicle: Object,
            setIntegrationError: Function,
            setIntegrationAppointmentDetails: Function,
            setAppointmentIdForIntegration: Function,
            showSnackbar: Function,
            currentIntegration: String,
            integrationVehicles: Array, 
            getIntegrationAppointments: Function,
            eligibleToSaveDeliveryContact: Boolean,
            primaryCustomerAddress: Object,
            updateIntegrationVehicles: Function,
            handleAddCustomerVehicle: Function,
            vehicleInfo: Object,
            selectedVehicle: Object,
            customerCommunicationInfo: Object,
            handleCreateVehicle: Function,
            setSelectedVehicle: Function,
        },
    });
</script>

<style lang="scss" scoped>
</style>
